import { BRAND } from '../../../../constants';
import ServerContext from '../../../../contexts/serverContext';
import AccordionItem from '../../../components/AccordionItem/AccordionItem';
import { OwnerManualResponse } from '../../../services/owner-manual-service/owner-manual-service';
import { CA_NO_PASTPRINTINGS, OWNER_MANUALS } from '../../../support-constants';
import { Item } from '../models/item';
import { OwnerManualProps } from './use-owner-manual-content';
import React, { useContext } from 'react';
import {
    getArticleDetails,
    pastPrintingsFunction,
} from '../../../components/owner-manual-categories-print/owner-manual-categories-print';

interface OMCategoriesProps {
    ownerManualContent: OwnerManualProps | null;
    ownerManualData: OwnerManualResponse | null;
    downloadAnalytic(guideName: string): void;
}
export const OwnerManualCategories = (props: OMCategoriesProps) => {
    const { ownerManualData, ownerManualContent } = props;
    const serverContext = useContext(ServerContext);

    const frameIdByCategory = (categoryName: string) => {
        return categoryName.trim().replace(/\s+/g, '-') + '-h2id';
    };

    return ownerManualData ? (
        <div>
            {Object.keys(ownerManualData)
                .sort(
                    (a: string, b: string) =>
                        OWNER_MANUALS.OM_SORTING_ORDER_BY_CATEGORY_ID.indexOf(
                            parseInt(a)
                        ) -
                        OWNER_MANUALS.OM_SORTING_ORDER_BY_CATEGORY_ID.indexOf(
                            parseInt(b)
                        )
                )
                .map(category => {
                    let categoryName = '';
                    const isCanadaTransit =
                        serverContext.brand === BRAND.ford.LONG_NAME &&
                        CA_NO_PASTPRINTINGS.regions.includes(
                            serverContext.currentLanguageRegionCode
                        ) &&
                        CA_NO_PASTPRINTINGS.vehicles.includes(
                            ownerManualData.metadata.displayModelName.toLowerCase()
                        );
                    const sortedOMDataCategory = ownerManualData[
                        parseInt(category)
                    ]
                        ? [...ownerManualData[parseInt(category)]]?.sort(
                              (a: Item, b: Item) =>
                                  b.metaData.version - a.metaData.version
                          )
                        : [];
                    const currentPrintings = sortedOMDataCategory.map(
                        (article, key) => {
                            const {
                                categoryName: newCategoryName,
                                articleCondition,
                            } = getArticleDetails(
                                sortedOMDataCategory,
                                article,
                                categoryName
                            );
                            categoryName = newCategoryName;

                            if (
                                article.secondaryCategory === 'HTML' ||
                                (article.secondaryCategory === 'PDF' &&
                                    key == articleCondition) ||
                                isCanadaTransit
                            )
                                return (
                                    <li key={article.title}>
                                        <a
                                            href={article.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={() => {
                                                props.downloadAnalytic(
                                                    article.title
                                                );
                                            }}
                                        >
                                            <div className="om-article-title">
                                                <span className="manual-guide-span">
                                                    {article.title}
                                                </span>
                                                {ownerManualContent && (
                                                    <span className="view-span">
                                                        {
                                                            ownerManualContent.detailsViewDocument
                                                        }
                                                    </span>
                                                )}
                                            </div>
                                        </a>
                                        {article.additionalLinks
                                            .nameValueOfString.length > 0 &&
                                            article.additionalLinks.nameValueOfString.map(
                                                addLink => {
                                                    return (
                                                        <a
                                                            key={addLink.name}
                                                            href={addLink.value}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            onClick={() => {
                                                                props.downloadAnalytic(
                                                                    addLink.name
                                                                );
                                                            }}
                                                        >
                                                            <li
                                                                className="om-article-title"
                                                                key={
                                                                    addLink.name
                                                                }
                                                            >
                                                                <span className="manual-guide-span">
                                                                    {
                                                                        addLink.name
                                                                    }
                                                                </span>
                                                                {ownerManualContent && (
                                                                    <span className="view-span">
                                                                        {
                                                                            ownerManualContent.detailsViewDocument
                                                                        }
                                                                    </span>
                                                                )}
                                                            </li>
                                                        </a>
                                                    );
                                                }
                                            )}
                                    </li>
                                );
                        }
                    );

                    const pastPrintings = pastPrintingsFunction(
                        sortedOMDataCategory,
                        ownerManualData,
                        isCanadaTransit,
                        props.downloadAnalytic,
                        ownerManualContent
                    );
                    return (
                        <div key={categoryName}>
                            <h2 id={frameIdByCategory(categoryName)}>
                                {categoryName}
                            </h2>
                            <ul>{currentPrintings}</ul>
                            {!!pastPrintings.length && ownerManualContent && (
                                <>
                                    <h3>
                                        {
                                            ownerManualContent.detailsPastPrintings
                                        }
                                    </h3>
                                    <AccordionItem
                                        title={
                                            ownerManualContent.detailsPastPrintingsAccordionTitle
                                        }
                                        chevronLabel={
                                            ownerManualContent.detailsPastPrintingsAccordionSeeMore
                                        }
                                        id={categoryName}
                                    >
                                        <ul>{pastPrintings}</ul>
                                    </AccordionItem>
                                </>
                            )}
                        </div>
                    );
                })}{' '}
        </div>
    ) : (
        <></>
    );
};
